import makeUseGlobalClientState from 'ui-library/hooks/global-client-state/makeUseGlobalClientState';

/**
 * Shared global client state for tracking whether runs are expanded or collapsed.
 * Used by AssayGroup for rendering and NoteLinkedAssayDataPlugin for height estimation.
 */
export const runExpandedState = makeUseGlobalClientState<boolean>(true);
